import React from 'react';
import { v4 as uuid } from 'uuid';
import { Button, closeMenu, openMenu } from 'react-aria-menubutton';
import styled from 'styled-components';
import { muiChevronRight } from '@ally/metronome-icons';
import { Icon } from '../../../Icon/Icon';
import { TextBodyDEPRECATED } from '../../../TypographyDEPRECATED/Text';
import { Box } from '../../../Box';
import { addAllyTM } from '../../../tools/utils';
const StyledIcon = styled(Icon) `
  transform: ${({ isOpen }) => (isOpen ? 'none' : 'rotate(270)')};
`;
const ContentItem = ({ content, }) => {
    if (React.isValidElement(content)) {
        return content;
    }
    if (typeof content === 'string') {
        return (React.createElement(TextBodyDEPRECATED, { tag: "p", size: "md", color: "bluesuedeshoes", lineHeight: "inherit" }, content));
    }
    return null;
};
const TriggerContent = ({ content, isOpen, }) => {
    return (React.createElement(Box, { display: "flex", alignItems: "center", width: "100%" },
        React.createElement(StyledIcon, { icon: muiChevronRight, fill: "bluesuedeshoes", size: "xs", isOpen: isOpen, mr: "xxs" }),
        React.createElement(ContentItem, { content: content })));
};
const StyledButton = styled(Button)(({ theme: { colors }, $isOpen }) => `
    width: 100%;
    background: none;
    margin: 0;
    padding: 8px;
    cursor: pointer;
    border: none;
    border-bottom-color: ${colors['slate-3']};
    border-bottom-style: solid;
    border-bottom-width: ${$isOpen ? '1px' : '0'};
  `);
export const Trigger = ({ content, isOpen, wrapperId, withAllyTM = true, ariaLabel, }) => {
    const handleOnClick = () => {
        return isOpen
            ? closeMenu(wrapperId, { focusButton: true })
            : openMenu(wrapperId, { focusMenu: true });
    };
    const { current: buttonUUID } = React.useRef(uuid());
    const safeId = wrapperId || `subMenuTrigger${buttonUUID}`;
    const allyTM = addAllyTM({
        content,
        id: safeId,
        elementType: 'interactive',
        withAllyTM,
    });
    const isContentString = typeof content === 'string';
    const defaultAriaLabel = isContentString ? content : undefined;
    return (React.createElement(StyledButton, Object.assign({ "$isOpen": isOpen, tabIndex: 0, onClick: handleOnClick, tag: "button", "aria-label": ariaLabel || defaultAriaLabel }, allyTM),
        React.createElement(TriggerContent, { content: content, isOpen: isOpen })));
};
//# sourceMappingURL=Trigger.js.map